"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ListFilter = _interopRequireDefault(require("@/components/ListFilter"));
var _rensouApi = require("@/api/rensou/rensouApi");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RsGoodsList',
  components: {
    ListFilterVue: _ListFilter.default
  },
  data: function data() {
    return {
      loading: false,
      query: {
        spuName: '',
        // 商品名称
        brandName: '',
        // 品牌名称
        spuId: '',
        // 商品ID
        showCateId: '',
        // 展示分类
        cateId: '',
        // 商品分类
        orderBy: '',
        // 排序方式
        createTimeStart: '',
        // 创建开始时间
        createTimeEnd: '',
        // 创建结束时间
        updateTimeStart: '',
        // 更新开始时间
        updateTimeEnd: '',
        // 更新结束时间
        status: '',
        // 商品状态
        merchantStatus: '',
        // 商户状态
        storeId: '' // 店铺ID
      },
      displayCategories: [],
      categories: [],
      cascaderProps: {
        checkStrictly: true,
        value: 'id',
        label: 'name',
        children: 'children',
        emitPath: false
      },
      sortOptions: [{
        label: '创建时间升序',
        value: 'createTimeAsc'
      }, {
        label: '创建时间降序',
        value: 'createTimeDesc'
      }, {
        label: '更新时间升序',
        value: 'updateTimeAsc'
      }, {
        label: '更新时间降序',
        value: 'updateTimeDesc'
      },
      // { label: '销量升序', value: 'sales_asc' },
      // { label: '销量降序', value: 'sales_desc' },
      {
        label: '价格升序',
        value: 'priceAsc'
      }, {
        label: '价格降序',
        value: 'priceDesc'
      }],
      tableData: [],
      // 数据同步店铺选择列表
      syncStoreData: [],
      // 数据同步弹窗显示状态
      syncDialogVisible: false,
      // 选中的店铺 key 列表
      selectedStoreKeys: [],
      // 当前同步的商品 wmTgFlag
      currentSyncWmTgFlag: null,
      // 当前同步的商品店铺类型
      currentSyncStoreType: null,
      // 当前同步的商品详情缓存
      currentSyncProductInfo: null,
      currentId: null,
      pageInfo: {
        page: 1,
        limit: 20,
        total: 0
      }
    };
  },
  mounted: function mounted() {
    this.getGoodsList();
    this.getGoodsCategoryList();
    this.getDisplayCategoryList();
  },
  methods: {
    getGoodsList: function () {
      var _getGoodsList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var params, response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              // 构建请求参数，过滤掉空值
              params = {
                page: this.pageInfo.page,
                limit: this.pageInfo.limit
              }; // 添加搜索参数，只添加有值的参数
              Object.keys(this.query).forEach(function (key) {
                var value = _this.query[key];
                if (value !== '' && value !== null && value !== undefined) {
                  params[key] = value;
                }
              });
              console.log('请求参数:', params); // 用于调试
              _context.n = 2;
              return (0, _rensouApi.goodsList)(params);
            case 2:
              response = _context.v;
              if (response && response.list) {
                this.tableData = response.list;
                this.pageInfo.total = response.total || 0;
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('获取商品列表失败:', _t);
              this.$message.error('获取商品列表失败');
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getGoodsList() {
        return _getGoodsList.apply(this, arguments);
      }
      return getGoodsList;
    }(),
    handleSizeChange: function handleSizeChange(val) {
      this.pageInfo.limit = val;
      this.pageInfo.page = 1;
      this.getGoodsList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getGoodsList();
    },
    handleSearch: function handleSearch() {
      this.pageInfo.page = 1;
      this.getGoodsList();
    },
    handleStoreIdInput: function handleStoreIdInput(val) {
      this.query.storeId = String(val || '').replace(/\D/g, '');
    },
    handleReset: function handleReset() {
      // 重置搜索条件
      this.query = {
        spuName: '',
        spuId: '',
        showCateId: '',
        cateId: '',
        orderBy: '',
        createTimeStart: '',
        createTimeEnd: '',
        updateTimeStart: '',
        updateTimeEnd: '',
        status: '',
        merchantStatus: '',
        storeId: ''
      };
      this.pageInfo.page = 1;
      this.getGoodsList();
    },
    handleAdd: function handleAdd() {
      this.$router.push({
        name: 'goodsAdd'
      });
    },
    handleEdit: function handleEdit(id) {
      this.$router.push({
        name: 'goodsEdit',
        params: {
          id: id
        }
      });
    },
    handleCopy: function handleCopy(id) {
      // 跳转到编辑页面，但通过 query 标记为复制模式。
      // 编辑页面在提交时应检测 route.query.copy 并在复制模式下不提交 id 字段。
      this.$router.push({
        name: 'goodsEdit',
        params: {
          id: id
        },
        query: {
          copy: 1
        }
      });
    },
    // 数据同步按钮点击事件
    handleSyncData: function () {
      var _handleSyncData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var loading, _yield$Promise$all, _yield$Promise$all2, productInfo, syncedStoreIds, historyDataError, allStores, availableStoreKeys, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              console.log('数据同步 row:', row);
              // 保存当前同步的商品 id 和 wmTgFlag
              this.currentId = row.id;
              this.currentSyncWmTgFlag = row.wmTgFlag;
              this.currentSyncStoreType = row.storeType || null;
              this.currentSyncProductInfo = null;

              // 显示加载提示
              loading = this.$loading({
                lock: true,
                text: '正在加载店铺数据...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context2.p = 1;
              _context2.n = 2;
              return Promise.all([(0, _rensouApi.getMerchantProductInfo)(this.currentId), this.fetchSyncedStoreIds(row.spuCode, row.storeId)]);
            case 2:
              _yield$Promise$all = _context2.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              productInfo = _yield$Promise$all2[0];
              syncedStoreIds = _yield$Promise$all2[1];
              historyDataError = this.getSyncHistoryDataError(productInfo);
              if (!historyDataError) {
                _context2.n = 3;
                break;
              }
              loading.close();
              this.$message.warning(historyDataError);
              return _context2.a(2);
            case 3:
              this.currentSyncProductInfo = productInfo;
              this.currentSyncStoreType = productInfo.storeType;
              _context2.n = 4;
              return this.fetchAllStores(row.wmTgFlag, row.storeId, productInfo.storeType);
            case 4:
              allStores = _context2.v;
              availableStoreKeys = allStores.map(function (store) {
                return String(store.key);
              }); // 设置店铺列表（已过滤当前店铺）
              this.syncStoreData = allStores;
              console.log('可选店铺列表:', this.syncStoreData);
              if (this.syncStoreData.length) {
                _context2.n = 5;
                break;
              }
              loading.close();
              this.$message.warning('暂无符合当前商品店铺类型的可同步店铺');
              return _context2.a(2);
            case 5:
              // 设置已同步的店铺ID（用于回显，已过滤当前店铺）
              this.selectedStoreKeys = syncedStoreIds.filter(function (storeId) {
                return availableStoreKeys.includes(String(storeId));
              });
              console.log('已同步的店铺ID:', this.selectedStoreKeys);
              loading.close();

              // 打开弹窗
              this.syncDialogVisible = true;
              _context2.n = 7;
              break;
            case 6:
              _context2.p = 6;
              _t2 = _context2.v;
              loading.close();
              console.error('加载店铺数据失败:', _t2);
              this.$message.error(_t2.message || '加载店铺数据失败');
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 6]]);
      }));
      function handleSyncData(_x) {
        return _handleSyncData.apply(this, arguments);
      }
      return handleSyncData;
    }(),
    // 获取所有店铺列表（排除当前店铺）
    fetchAllStores: function () {
      var _fetchAllStores = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(wmTgFlag, currentStoreId, currentStoreType) {
        var _this2 = this;
        var params, response;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              params = {
                online: 1
              };
              if (wmTgFlag !== null && wmTgFlag !== undefined) {
                params.wmTgFlag = wmTgFlag;
              }
              _context3.n = 1;
              return (0, _rensouApi.getStore)(params);
            case 1:
              response = _context3.v;
              console.log('所有店铺列表>>>>>>>:', response);
              console.log('当前店铺ID>>>>>>>:', currentStoreId);
              // 过滤掉当前商品所属的店铺（不需要同步到自己）
              // 同时仅保留已配置当前商品店铺类型的目标店铺
              return _context3.a(2, response.filter(function (store) {
                if (String(store.key) === String(currentStoreId)) {
                  return false;
                }
                var storeTypesValue = store.storeTypes !== undefined && store.storeTypes !== null ? store.storeTypes : store.storeType;
                var storeTypes = _this2.parseStoreTypes(storeTypesValue);
                return storeTypes.includes(Number(currentStoreType));
              }));
          }
        }, _callee3);
      }));
      function fetchAllStores(_x2, _x3, _x4) {
        return _fetchAllStores.apply(this, arguments);
      }
      return fetchAllStores;
    }(),
    // 获取已同步的店铺ID列表
    fetchSyncedStoreIds: function () {
      var _fetchSyncedStoreIds = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(spuCode, currentStoreId) {
        var response, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (spuCode) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, []);
            case 1:
              _context4.p = 1;
              _context4.n = 2;
              return (0, _rensouApi.getStoreIdsBySpuCode)(spuCode);
            case 2:
              response = _context4.v;
              console.log('已同步店铺响应:', response);
              // 返回格式为数组 [631, 632]
              if (!Array.isArray(response)) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2, response.filter(function (storeId) {
                return storeId !== currentStoreId;
              }));
            case 3:
              return _context4.a(2, []);
            case 4:
              _context4.p = 4;
              _t3 = _context4.v;
              console.warn('获取已同步店铺ID失败:', _t3);
              // 如果获取失败，返回空数组，不影响主流程
              return _context4.a(2, []);
          }
        }, _callee4, null, [[1, 4]]);
      }));
      function fetchSyncedStoreIds(_x5, _x6) {
        return _fetchSyncedStoreIds.apply(this, arguments);
      }
      return fetchSyncedStoreIds;
    }(),
    // 确认同步数据
    confirmSyncData: function () {
      var _confirmSyncData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var loading, productInfo, historyDataError, _t4, _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!(this.selectedStoreKeys.length === 0)) {
                _context5.n = 1;
                break;
              }
              this.$message.warning('请至少选择一个店铺');
              return _context5.a(2);
            case 1:
              console.log('选中的店铺 keys:', this.selectedStoreKeys);
              console.log('当前商品 id:', this.currentId);

              // 关闭弹窗
              this.syncDialogVisible = false;

              // 显示加载提示
              loading = this.$loading({
                lock: true,
                text: '正在同步商品数据...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context5.p = 2;
              _t4 = this.currentSyncProductInfo;
              if (_t4) {
                _context5.n = 4;
                break;
              }
              _context5.n = 3;
              return (0, _rensouApi.getMerchantProductInfo)(this.currentId);
            case 3:
              _t4 = _context5.v;
            case 4:
              productInfo = _t4;
              if (productInfo) {
                _context5.n = 5;
                break;
              }
              throw new Error('获取商品信息失败');
            case 5:
              historyDataError = this.getSyncHistoryDataError(productInfo);
              if (!historyDataError) {
                _context5.n = 6;
                break;
              }
              throw new Error(historyDataError);
            case 6:
              // 删除id字段
              delete productInfo.id;

              // 添加同步店铺ID
              productInfo.syncStoreIds = this.selectedStoreKeys.map(function (id) {
                return parseInt(id);
              }).filter(function (id) {
                return !isNaN(id);
              });
              console.log('同步数据payload:', productInfo);

              // 调用新增接口进行同步
              _context5.n = 7;
              return (0, _rensouApi.createMerchantProduct)(productInfo);
            case 7:
              loading.close();
              this.$message.success('商品同步成功！');
              this.currentSyncProductInfo = null;
              this.currentSyncStoreType = null;
              this.currentSyncWmTgFlag = null;
              this.selectedStoreKeys = [];

              // 刷新列表
              this.getGoodsList();
              _context5.n = 9;
              break;
            case 8:
              _context5.p = 8;
              _t5 = _context5.v;
              loading.close();
              console.error('商品同步失败:', _t5);
              this.$message.error(_t5.message || '同步失败，请重试');
            case 9:
              return _context5.a(2);
          }
        }, _callee5, this, [[2, 8]]);
      }));
      function confirmSyncData() {
        return _confirmSyncData.apply(this, arguments);
      }
      return confirmSyncData;
    }(),
    parseStoreTypes: function parseStoreTypes(value) {
      if (value === null || value === undefined || value === '') {
        return [];
      }
      var values = Array.isArray(value) ? value : String(value).split(',');
      return values.map(function (item) {
        return Number(String(item).trim());
      }).filter(function (item) {
        return !Number.isNaN(item);
      });
    },
    parseExtraObject: function parseExtraObject(value) {
      if (!value) {
        return null;
      }
      if (_typeof(value) === 'object') {
        return value;
      }
      try {
        return JSON.parse(value);
      } catch (error) {
        return null;
      }
    },
    hasMultipleAttrMissingCostPrice: function hasMultipleAttrMissingCostPrice(multipleAttr) {
      if (!multipleAttr || !Array.isArray(multipleAttr.attrGroups)) {
        return true;
      }
      return multipleAttr.attrGroups.some(function (group) {
        if (!group || !Array.isArray(group.attrValues)) {
          return true;
        }
        return group.attrValues.some(function (attrValue) {
          return attrValue.costPrice === null || attrValue.costPrice === undefined || attrValue.costPrice === '';
        });
      });
    },
    hasSkuAttrMissingConfig: function hasSkuAttrMissingConfig(productInfo) {
      if (!Array.isArray(productInfo.attr) || productInfo.attr.length === 0) {
        return true;
      }
      if (!Array.isArray(productInfo.attrValue) || productInfo.attrValue.length === 0) {
        return true;
      }
      var hasCheckedSku = productInfo.attrValue.some(function (item) {
        return item && item.checked === true;
      });
      if (!hasCheckedSku) {
        return true;
      }
      return productInfo.attrValue.some(function (item) {
        return !item || item.costPrice === null || item.costPrice === undefined || item.costPrice === '';
      });
    },
    getSyncHistoryDataError: function getSyncHistoryDataError(productInfo) {
      if (!productInfo) {
        return '获取商品信息失败，请稍后重试';
      }
      if (productInfo.storeType === null || productInfo.storeType === undefined || productInfo.storeType === '') {
        return '该商品为历史数据，缺少店铺类型，请先进入编辑页补充并保存后再同步';
      }
      if (Number(productInfo.attrType) === 2 && this.hasMultipleAttrMissingCostPrice(productInfo.multipleAttr)) {
        return '该商品为历史数据，缺少多规格无库存成本价，请先进入编辑页补充并保存后再同步';
      }
      if (Number(productInfo.attrType) === 3 && this.hasSkuAttrMissingConfig(productInfo)) {
        return '该商品为历史数据，缺少SKU规格定义、默认规格或成本价，请先进入编辑页补充并保存后再同步';
      }
      if (Number(productInfo.wmTgFlag) === 3) {
        var hotelExtra = this.parseExtraObject(productInfo.hotelExtra);
        if (!productInfo.deadlineTime || !hotelExtra || hotelExtra.customerCancelDays === undefined || !hotelExtra.customerCancelTime) {
          return '该酒店商品为历史数据，缺少客户可取消时间配置，请先进入编辑页补充并保存后再同步';
        }
      }
      if (Number(productInfo.wmTgFlag) === 2 && Number(productInfo.appointmentTimeFlag) === 1) {
        var appointmentExtra = this.parseExtraObject(productInfo.appointmentExtra);
        if (!productInfo.deadlineTime || !appointmentExtra || appointmentExtra.refundDays === undefined || !appointmentExtra.refundTime) {
          return '该预约团购商品为历史数据，缺少预约时间配置，请先进入编辑页补充并保存后再同步';
        }
      }
      return '';
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;
      this.$confirm('确定删除该商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return (0, _rensouApi.deleteMerchantProduct)(id);
            case 1:
              _this3.$message.success('删除成功');
              _this3.getGoodsList();
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      })));
    },
    //同步删除所有数据方法
    syncDelete: function syncDelete(id) {
      var _this4 = this;
      this.$confirm('确定同步删除该商品和所有同步数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return (0, _rensouApi.deleteMerchantAllSyncData)(id);
            case 1:
              _this4.$message.success('商户同步删除成功');
              _this4.getGoodsList();
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      })));
    },
    handleStatusChange: function handleStatusChange(id, status) {
      console.log(id, status);
      (0, _rensouApi.updateProductStatus)(id, status);
      this.query.status = status;
      this.$message.success("\u72B6\u6001".concat(status === 1 ? '上架' : '下架', "\u6210\u529F"));
    },
    // 获取商户商品分类
    getGoodsCategoryList: function () {
      var _getGoodsCategoryList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var res, _t6;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _context8.p = 0;
              _context8.n = 1;
              return (0, _rensouApi.getGoodsCategory)();
            case 1:
              res = _context8.v;
              if (res && res.length > 0) {
                this.categories = this.processTreeData(res);
              }
              _context8.n = 3;
              break;
            case 2:
              _context8.p = 2;
              _t6 = _context8.v;
              console.error('获取商品分类失败:', _t6);
              this.$message.error('获取商品分类失败');
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this, [[0, 2]]);
      }));
      function getGoodsCategoryList() {
        return _getGoodsCategoryList.apply(this, arguments);
      }
      return getGoodsCategoryList;
    }(),
    // 获取展示分类
    getDisplayCategoryList: function () {
      var _getDisplayCategoryList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var res, _t7;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.p = 0;
              _context9.n = 1;
              return (0, _rensouApi.getDisplayCategory)();
            case 1:
              res = _context9.v;
              if (res && res.length > 0) {
                // 将展示分类处理为级联选择器格式
                this.displayCategories = this.processTreeData(res);
              }
              _context9.n = 3;
              break;
            case 2:
              _context9.p = 2;
              _t7 = _context9.v;
              console.error('获取展示分类失败:', _t7);
              this.$message.error('获取展示分类失败');
            case 3:
              return _context9.a(2);
          }
        }, _callee9, this, [[0, 2]]);
      }));
      function getDisplayCategoryList() {
        return _getDisplayCategoryList.apply(this, arguments);
      }
      return getDisplayCategoryList;
    }(),
    handleCategoryChange: function handleCategoryChange(value) {
      // 级联选择器值变化时的处理
      console.log('Selected category:', value);
      // 如果需要在选择分类时立即搜索，可以调用 this.handleSearch()
    },
    handleDisplayCategoryChange: function handleDisplayCategoryChange(value) {
      // 展示分类级联选择器值变化时的处理
      console.log('Selected display category:', value);
      // 如果需要在选择分类时立即搜索，可以调用 this.handleSearch()
    },
    // 处理树形数据，确保每个节点都有正确的属性
    processTreeData: function processTreeData(data) {
      var _this5 = this;
      return data.map(function (item) {
        return {
          id: item.id,
          name: item.name,
          children: item.children && item.children.length > 0 ? _this5.processTreeData(item.children) : []
        };
      });
    },
    // 将树形数据展平为选择器选项
    flattenTreeToOptions: function flattenTreeToOptions(data) {
      var _this6 = this;
      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var options = [];
      data.forEach(function (item) {
        var prefix = '　'.repeat(level); // 使用全角空格缩进表示层级
        options.push({
          label: prefix + item.name,
          value: item.id
        });
        if (item.children && item.children.length > 0) {
          options = options.concat(_this6.flattenTreeToOptions(item.children, level + 1));
        }
      });
      return options;
    }
  }
};